import React, { useEffect } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../../common/hooks/redux';
import { useDispatch, useSelector } from 'react-redux';
import { Sidebar } from '../../navigation';
import { Header } from '../Header';
import { hideMessage } from '../../../store/reducers/message.reducer';
import Message from '../../../common/components/message';
import { useUserProfile } from '../../../domains/user';
// import { connectMessaging } from '../../../store/reducers/userSlice';
import './MainLayout.scss';

/**
 * MainLayout Component
 * Main application layout with navigation and content
 * Based on Flow project Main.tsx structure
 */
const MainLayout: React.FC = () => {
  const dispatch = useDispatch();
  const message = useSelector((state: any) => state.message);
  const userRole = useAppSelector(state => state.auth?.user?.role || 'none');
  const user = useAppSelector(state => state.auth?.user);
  useUserProfile();

  useEffect(() => {
    if (userRole !== 'none') {
      // TODO: Add messaging connection when implemented
      // dispatch(connectMessaging());
      // TODO: Add settings loading if needed
      // user && loadSettings(`user_${user.id}`);
    }
  }, [userRole, dispatch, user?.id]);

  return (
    <Flex id='main' className='dashboard' direction='column'>
      <Header showLanguageSelector />
      <Flex className='dashboard__body' flex={1}>
        <Sidebar />
        <Flex {...getWrapStyle()} className='dashboard__content'>
          {message && message.value && (
            <Message callback={() => dispatch(hideMessage())} {...message} />
          )}
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
};

/**
 * Get wrap style with custom scrollbar styling
 * Based on Flow project getWrapStyle function
 */
const getWrapStyle = (): FlexProps =>
  ({
    w: 'full',
    h: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    sx: {
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '5px',
        borderRadius: '15px',
        backgroundColor: `rgba(0, 0, 0, 0.05)`,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: `rgba(0, 0, 0, 0.2)`,
        borderRadius: '15px',
      },
    },
    css: { '& > div': { overflow: 'unset', maxW: '1150px' } },
  }) as FlexProps;

export default MainLayout;
